import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  container: {
    width: "100%",
    color: "#fff",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "0",
    },
  },
  contentWrapper: {
    maxWidth: "780px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 48,
    paddingTop: "16px",
    [theme.breakpoints.down("sm")]: {
      padding: "20px 0",
      gap: 32,
    },
  },
  header: {
    color: "#f06ec4",
    fontSize: "24px",
    fontWeight: 600,
    marginBottom: theme.spacing(4),
    paddingBottom: theme.spacing(1),
    borderBottom: "1px solid #363636",
  },
  profileSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
    marginLeft: "82px",
    [theme.breakpoints.down("sm")]: {
      margin: "10px 0 0 0",
    },
  },
  profileImage: {
    width: "48px",
    height: "48px",
    borderRadius: "50%",
    objectFit: "cover",
    border: "2px solid #f06ec4",
  },
  profileTextContainer: {
    display: "flex",
    flexDirection: "column",
  },
  creatorText: {
    color: "#fff",
    fontSize: "16px",
    fontWeight: 600,
    marginBottom: "0px",
  },
  creatorTextHelp: {
    color: "#FE5A97",
    fontSize: "13px",
    fontWeight: 600,
    marginBottom: "0px",
  },
  changePhotoText: {
    color: "#f06ec4",
    fontSize: "14px",
    fontWeight: 400,
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
    textTransform: "none",
    "&:hover": {
      textDecoration: "underline",
      background: "none",
    },
  },
  formRow: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: 20,
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  formRowNamme: {
    display: "flex",
    // alignItems: "flex-start",
    flexDirection: "column",
    // marginBottom: theme.spacing(2),
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  formRowNammeContainer: {
    display: "flex",
    gap: 20,
    [theme.breakpoints.down("xs")]: {
      columnGap: "10px",
      flexDirection: "column",
    },
  },
  inputsBox: {
    width: "50%",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  label: {
    color: "#fff",
    fontSize: "14px",
    fontWeight: 500,
    marginRight: "8px",
    [theme.breakpoints.down("sm")]: {
      textAlign: "left",
      fontSize: "12px",
    },
  },
  labell: {
    width: "90px",
    color: "#fff",
    fontSize: "16px",
    fontWeight: 500,
    textAlign: "left",
    marginRight: "8px",
    [theme.breakpoints.down("sm")]: {
      textAlign: "left",
      width: "55px",
    },
  },
  fieldContainer: {
    flex: 1,
    width: "100%",
    maxWidth: 380,
    [theme.breakpoints.down("xs")]: {
      maxWidth: "100%",
    },
  },
  fieldContainerHelp: {
    flex: 1,
    width: "100%",
    minWidth: 100,
    maxWidth: 380,
    [theme.breakpoints.down("xs")]: {
      maxWidth: "100%",
    },
  },
  inputField: {
    width: "100%",
    "& .MuiInputBase-root": {
      color: "#fff",
      fontSize: "16px",
      borderRadius: "8px",
      border: "1px solid #747474",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#EDECED",
      },
      "&:hover fieldset": {
        borderColor: "#f06ec4",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#f06ec4",
      },
    },
    "& .MuiSelect-icon": {
      color: "#fff",
    },
  },
  inputFieldHelp: {
    width: "100%",
    "& .MuiInputBase-root": {
      color: "#fff",
      fontSize: "16px",
      borderRadius: "8px",
      border: "1px solid #747474",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#EDECED",
      },
      "&:hover fieldset": {
        borderColor: "#f06ec4",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#f06ec4",
      },
    },
    "& .MuiSelect-icon": {
      color: "#fff",
    },
  },
  helperText: {
    color: "#FFFFFF",
    fontSize: "12px",
    marginTop: "4px",
  },
  helperTextHelp: {
    color: "#FFFFFF",
    fontSize: "12px",
    marginTop: "4px",
    marginLeft: "100px",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0",
    },
  },
  pinkText: {
    color: "#f06ec4",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
      color: "#f06ec4",
    },
    "&:focus": {
      textDecoration: "none",
    },
  },
  pinkForWord: {
    color: "#f06ec4",
    textDecoration: "none",
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
  sectionTitleWrapper: {
    // marginBottom: theme.spacing(2),
  },
  sectionTitle: {
    color: "#fff",
    fontSize: "20px",
    fontWeight: 700,
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
  sectionMainTitle: {
    fontSize: "32px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
  },
  sectionDescription: {
    color: "#FFFFFF",
    fontSize: "14px",
    fontWeight: 400,
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0",
    },
  },
  bioCounter: {
    color: "#999999",
    fontSize: "12px",
    marginTop: "4px",
    textAlign: "right",
  },
  checkbox: {
    color: "#f06ec4",
    marginRight: 0,
    "&.Mui-checked": {
      color: "#f06ec4",
    },
    verticalAlign: "middle",
  },
  checkboxLabel: {
    color: "#fff",
    fontWeight: 500,
    fontSize: "16px",
    display: "inline",
    verticalAlign: "middle",
  },
  checkboxWrapper: {
    display: "inline-flex",
    alignItems: "center",
    paddingTop: "10px",
  },
  formButtonsWrapper: {
    marginBottom: 95,
    marginTop: 48,
    gap: 20,
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      marginBottom: 24,
      marginTop: 24,
    },
  },
  formButtons: {
    color: "white",
    fontWeight: 600,
    borderRadius: "6px",
    padding: "20px 40px",
    maxHeight: 60,
    float: "left",
    textTransform: "none",
    fontSize: "20px",
    width: "max-content",
    minWidth: 333,
    "&:hover": {
      backgroundColor: "#d45ca5",
    },
    [theme.breakpoints.down("md")]: {
      minWidth: "45%",
    },
    [theme.breakpoints.down("sm")]: {
      minWidth: "40%",
      width: "50%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  cancelButton: {
    border: "1px solid #FE5A97",
  },
  submitButton: {
    backgroundColor: "#FE5A97",
  },
  formRowMessages: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    marginLeft: "30px",
    height: "20px",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  labelMessages: {
    color: "#fff",
    fontSize: "16px",
    fontWeight: 500,
    width: "120px",
  },
  messageContainer: {
    display: "flex",
    alignItems: "center",
    gap: "2px",
  },
  allowText: {
    color: "#fff",
    fontSize: "16px",
    fontWeight: 500,
    marginLeft: 0,
  },
  menuItem: {
    color: "#fff",
    "&:hover": {
      backgroundColor: "#333",
    },
  },
  dropdownPaper: {
    padding: "0px",
    height: "185px",
    maxHeight: "200px",
  },
}));
